import { defaultChartConfig, fontFamily, fontStyle } from '../chart.config';

export const configDoughnutChart = {
  doughnutChartType: 'doughnut',
  doughnutChartOptions: {
    ...defaultChartConfig,
    cutoutPercentage: 70,
    legend: {
      display: true,
      position: 'bottom',
      fontFamily: fontFamily,
      fontStyle: fontStyle,
      labels: {
        padding: 36
      }
    }
  }
};
